import { usePaletteTheme } from '../../context/paletteTheme'
import { LightMode, DarkMode } from '@mui/icons-material'
import { Button } from '@mui/material'
import styles from './Header.module.scss'

const ThemeSwitcherButton = () => {
    const { checked, handleChangeSwitch } = usePaletteTheme()

    return (
        <Button onClick={handleChangeSwitch} classes={{root: styles['switcher-btn']}} >
            {checked ? <LightMode color='textPrimary'/> : <DarkMode color='textPrimary'/> }
        </Button>
    )
}

export default ThemeSwitcherButton